import { render } from "./BooleanField.vue?vue&type=template&id=6d2d1ec6"
import script from "./BooleanField.vue?vue&type=script&lang=js"
export * from "./BooleanField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BooleanField.vue"]])

export default __exports__